/** Off by default — set REACT_APP_MULTISTORE_OFFERS_ENABLED=true to re-enable storefront grouping. */
export const multistoreOffersEnabled = process.env.REACT_APP_MULTISTORE_OFFERS_ENABLED === 'true';
